

<div class="player-container">

  <h2>{{ config.sectionTitle | translate }}</h2>

  <div class="tracks-container">
    <div class="tracks-list" #tracksList>
      @for (track of tracks; track track) {
        <div
          class="track-item"
          [class.active]="currentTrack?.id === track.id"
          (click)="playTrack(track)">
          <div class="track-info">
            <span class="track-title">{{ track.title }}</span>
            <span class="track-artist">{{ track.artist }}</span>
          </div>
          <span class="track-duration">{{ track.duration }}</span>
        </div>
      }
    </div>
  </div>

  <div class="player-controls">
    <div class="progress-container">
      <div class="progress-bar"
        (mousedown)="startSeek($event)"
        (mousemove)="seeking($event)"
        (mouseup)="endSeek()"
        (mouseleave)="endSeek()">
        <div class="progress" [style.width]="progress + '%'"></div>
      </div>
      <div class="time-info">
        <span>{{ currentTime | time }}</span>
        <span>{{ duration | time }}</span>
      </div>
    </div>

    <div class="controls">
      <button class="control-btn" (click)="previousTrack()" aria-label="Previous">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M19 20V4l-10 8 10 8zM5 20V4" stroke="currentColor" stroke-width="0" fill="currentColor" />
        </svg>
      </button>
      <button class="control-btn play-btn" (click)="togglePlay()" aria-label="Play/Pause">
        @if (isPlaying) {
          <!-- Pause icon -->
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <rect x="6" y="5" width="4" height="14" fill="currentColor" rx="1" />
            <rect x="14" y="5" width="4" height="14" fill="currentColor" rx="1" />
          </svg>
        } @else {
          <!-- Play icon -->
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M5 3v18l15-9L5 3z" fill="currentColor" />
          </svg>
        }
      </button>
      <button class="control-btn" (click)="nextTrack()" aria-label="Next">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M5 4v16l10-8L5 4zm14 0v16h-2V4h2z" fill="currentColor" />
        </svg>
      </button>

      <button class="control-btn" (click)="toggleRepeat()" aria-label="Repeat">
        @switch (repeat) {
          @case ('one') {
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M7 7h10v3l4-4-4-4v3H7v-2H5v6h2V7z" fill="currentColor" />
              <text x="12" y="17" font-size="10" text-anchor="middle" fill="currentColor">1</text>
            </svg>
          }
          @case ('all') {
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M7 7h10v3l4-4-4-4v3H7v-2H5v6h2V7z" fill="currentColor" />
              <path d="M7 17h10v-3l4 4-4 4v-3H7v2H5v-6h2v4z" fill="currentColor" />
            </svg>
          }
          @default {
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M7 7h10v3l4-4-4-4v3H7v-2H5v6h2V7z" fill="currentColor" />
            </svg>
          }
        }
      </button>


    </div>

    <button class="create-button" (click)="openTypeForm()">
      <span>{{ config.createButtonText | translate }}</span>
      <svg class="arrow-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>


  </div>
</div>
